import { PayloadAction } from '@reduxjs/toolkit';

import { VariantsState } from 'editor/src/store/variants/types';

const setSelectedProductUidReducer = (state: VariantsState, action: PayloadAction<string | undefined>) => {
  state.selectedProductUid = action.payload;
};

export default setSelectedProductUidReducer;
